import React from 'react';
import { Box, Typography } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { FormattedMessage } from 'react-intl';
import { useProductFormStyles } from './ProductForm.style';
import { EXTERNAL_URLS } from './constants';

/** Shown at top of edit drawer when the product is already public on the server. */
export const ProductPublicEditBanner: React.FC = () => {
  const classes = useProductFormStyles();
  return (
    <Box className={classes.publicEditBanner}>
      <InfoOutlined className={classes.publicEditBannerIcon} />
      <Box className={classes.publicEditBannerText}>
        <Typography component="div" className={classes.publicEditBannerTitle}>
          <FormattedMessage defaultMessage="Product is public" />
        </Typography>
        <Typography component="div" className={classes.publicEditBannerBody}>
          <FormattedMessage
            defaultMessage="Settings are locked to maintain stability for external developers. You may still add new application types. To request changes, contact {supportLink} and use keyword {keyword}."
            values={{
              supportLink: (
                <a
                  href={EXTERNAL_URLS.CLOUD_SUPPORT}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.publicEditBannerLink}
                >
                  <FormattedMessage defaultMessage="Cloud Support" />
                </a>
              ),
              keyword: <strong>API Cloud</strong>,
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
};
